/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContratChefEntrepriseDto
 */
export interface ContratChefEntrepriseDto {
    /**
     * 
     * @type {number}
     * @memberof ContratChefEntrepriseDto
     */
    idchefEntreprise?: number;
    /**
     * 
     * @type {string}
     * @memberof ContratChefEntrepriseDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratChefEntrepriseDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContratChefEntrepriseDto
     */
    idpersonne?: number | null;
}

/**
 * Check if a given object implements the ContratChefEntrepriseDto interface.
 */
export function instanceOfContratChefEntrepriseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratChefEntrepriseDtoFromJSON(json: any): ContratChefEntrepriseDto {
    return ContratChefEntrepriseDtoFromJSONTyped(json, false);
}

export function ContratChefEntrepriseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratChefEntrepriseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idchefEntreprise': !exists(json, 'idchefEntreprise') ? undefined : json['idchefEntreprise'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
    };
}

export function ContratChefEntrepriseDtoToJSON(value?: ContratChefEntrepriseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idchefEntreprise': value.idchefEntreprise,
        'nom': value.nom,
        'prenom': value.prenom,
        'idpersonne': value.idpersonne,
    };
}

